import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CHAIRS } from '../data/chairs';
import './ConferenceChairs.css';

interface Product {
  id: string;
  name: string;
  image: string;
}

const ConferenceChairs: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleChairClick = (chairId: string) => {
    navigate(`/conference-chairs/${chairId}`);
  };

  const products: Product[] = CHAIRS.map((c) => ({
    id: c.id,
    name: t(`chairs.${c.id}.name`),
    image: c.image,
  }));


  return (
    <div className="conference-chairs-page">
      {/* Hero */}
      <header className="chairs-hero">
        <div className="chairs-hero-inner">
          <span className="chairs-hero-label">{t('chairs.heroLabel')}</span>
          <h1>{t('chairs.pageTitle')}</h1>
          <p className="chairs-hero-sub">{t('chairs.subtitle')}</p>
          <div className="chairs-hero-count">
            <strong>{products.length}</strong> {t('chairs.modelsLabel')}
          </div>
        </div>
      </header>

      <div className="page-container">
        <section className="products-section">
          <div className="products-grid">
            {products.map((product, index) => (
              <div
                key={product.id}
                className="product-card"
                onClick={() => handleChairClick(product.id)}
              >
                <div className="product-image">
                  <img src={product.image} alt={product.name} />
                  <span className="product-index">{String(index + 1).padStart(2, '0')}</span>
                  <div className="product-overlay">
                    <span className="view-details">
                      {t('chairs.viewDetails')}
                      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12" />
                        <polyline points="12 5 19 12 12 19" />
                      </svg>
                    </span>
                  </div>
                </div>
                <div className="product-info">
                  <h3>{product.name}</h3>
                  <button
                    className="quote-button"
                    onClick={(e) => {
                      e.stopPropagation();
                      window.open(`https://wa.me/905408072727?text=${encodeURIComponent(`Merhaba, ${product.name} için teklif almak istiyorum.`)}`, '_blank');
                    }}
                  >
                    {t('common.getQuote')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ConferenceChairs;
